import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";

function fmt(d) {
  try {
    return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  } catch { return ""; }
}

export default function JournalPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/journal/${slug}`)
      .then((r) => setPost(r.data))
      .catch((e) => setErr(e.response?.data?.detail || "Not found"));
  }, [slug]);

  if (err) {
    return (
      <div className="hm-container py-40" data-testid="journal-post-error">
        <p className="hm-eyebrow mb-6">404</p>
        <h1 className="font-display" style={{ fontSize: "56px", fontWeight: 400 }}>Entry not found.</h1>
        <Link to="/journal" className="hm-link mt-8 inline-block">Back to journal →</Link>
      </div>
    );
  }
  if (!post) return <div className="hm-container py-40 text-[color:var(--hm-ink-dim)]">Loading…</div>;

  return (
    <article data-testid="journal-post">
      <header className="hm-container pt-32 pb-16 max-w-3xl mx-auto">
        <Link to="/journal" className="hm-eyebrow hover:text-[color:var(--hm-pink)] inline-block mb-10">← Journal</Link>
        <p className="hm-eyebrow mb-6">{fmt(post.created_at)}</p>
        <h1 className="font-display leading-[1.02] tracking-[-0.015em]" style={{ fontSize: "clamp(36px, 5vw, 70px)", fontWeight: 400 }}>{post.title}</h1>
        <p className="mt-8 text-[19px] text-[color:var(--hm-ink-dim)] leading-relaxed">{post.excerpt}</p>
      </header>

      {post.cover_image && (
        <div className="hm-container">
          <div className="aspect-[16/9] overflow-hidden mb-20">
            <img src={post.cover_image} alt="" className="w-full h-full object-cover" />
          </div>
        </div>
      )}

      <div className="hm-container max-w-3xl mx-auto pb-32">
        <div className="hm-prose">
          {post.body.split(/\n\n+/).map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>

        <div className="hm-rule mt-20 mb-8" />
        <Link to="/journal" className="hm-link">← All entries</Link>
      </div>
    </article>
  );
}
